<div class="megamenu-camiones">
  <div class="megamenu-camiones__inner" #inner>
    <nav class="megamenu-camiones__tabs" role="tablist">
      <button
        type="button"
        class="megamenu-camiones__tab"
        [class.is-active]="activeTab() === 'modelos'"
        role="tab"
        [attr.aria-selected]="activeTab() === 'modelos'"
        (click)="setTab('modelos')"
      >
        Modelos Mack
      </button>
      <button
        type="button"
        class="megamenu-camiones__tab"
        [class.is-active]="activeTab() === 'industrias'"
        role="tab"
        [attr.aria-selected]="activeTab() === 'industrias'"
        (click)="setTab('industrias')"
      >
        Industrias
      </button>
    </nav>

    <div
      class="megamenu-camiones__panel"
      [class.is-active]="activeTab() === 'modelos'"
      role="tabpanel"
    >
      <div class="megamenu-camiones__cards">
        @for (modelo of modelos(); track modelo.slug) {
          <div
            class="megamenu-camiones__card"
            (click)="modelo.showDetail ? navigateTo('/camiones/' + modelo.slug) : navigateToExternal(modelo.whatsUrl)"
            aria-hidden="true"
          >
            <div
              class="megamenu-camiones__card-img"
              [style.--card-bg]="modelo.backgroundListImage ? 'url(' + modelo.backgroundListImage + ')' : 'none'"
            >
              <img [ngSrc]="modelo.listImage.image" width="422" height="216" [alt]="modelo.listImage.alt" />
            </div>
            <div class="megamenu-camiones__card-body">
              @if (modelo.showDetail) {
                <a class="megamenu-camiones__card-name-link" [routerLink]="'/camiones/' + modelo.slug" (click)="onLink()">
                  <h3 class="megamenu-camiones__card-name">{{ modelo.title }}</h3>
                </a>
              } @else {
                <a class="megamenu-camiones__card-name-link" [href]="modelo.whatsUrl" target="_blank" rel="noopener" (click)="onLink()">
                  <h3 class="megamenu-camiones__card-name">{{ modelo.title }}</h3>
                </a>
              }
              <p class="megamenu-camiones__card-desc">{{ modelo.listDescription }}</p>
              <span class="btn-primary megamenu-camiones__card-btn">{{ modelo.showDetail ? 'Explora' : 'Contacta un asesor' }}</span>
            </div>
          </div>
        }
      </div>
      <div class="megamenu-camiones__footer">
        <a class="btn-secondary" routerLink="/camiones" (click)="onLink()"
          >Ver todos los camiones</a
        >
      </div>
    </div>

    <div
      class="megamenu-camiones__panel"
      [class.is-active]="activeTab() === 'industrias'"
      role="tabpanel"
    >
      <div class="megamenu-camiones__industrias">
        @for (industria of industrias(); track industria.slug) {
          <div class="megamenu-camiones__industria" (click)="navigateTo('/industrias/' + industria.slug)" aria-hidden="true">
            <div class="megamenu-camiones__industria-img">
              <img [ngSrc]="industria.listImage.image" width="315" height="184" [alt]="industria.listImage.alt" />
            </div>
            <div class="megamenu-camiones__industria-body">
              <a class="megamenu-camiones__industria-name-link" [routerLink]="'/industrias/' + industria.slug" (click)="onLink()"><h3 class="megamenu-camiones__industria-name">{{ industria.title }}</h3></a>
              <p class="megamenu-camiones__industria-desc">{{ industria.listDescription }}</p>
              <span class="btn-tertiary">
                <span class="btn-tertiary__label">Conoce más</span>
                <svg class="btn-tertiary__icon" viewBox="0 0 4 8" fill="none" aria-hidden="true">
                  <path d="M0.5 0.5L3 4L0.5 7.5" stroke="currentColor" stroke-width="1" />
                </svg>
              </span>
            </div>
          </div>
        }
      </div>
      <div class="megamenu-camiones__footer">
        <a class="btn-secondary" routerLink="/industrias" (click)="onLink()">Ver todas las industrias</a>
      </div>
    </div>
  </div>
</div>
